export default __webpack_public_path__ + "static/media/liquidity_provider_right_image.a71115a4.png";